// console.log("okey");

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".carousel").forEach((carousel) => {
    new Flickity(carousel, {
      cellAlign: "center",
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: true,
    });
  });
});
